import React, { useMemo } from 'react';
import { ViewerPropertiesComplete } from '../model';

export const iframeURL = (src: string) => {
  const url = new URL(src, origin);
  url.searchParams.set('full_preview', '1');
  return url.toString();
};

export const MediaIFrame: React.FC<ViewerPropertiesComplete> = ({ src, filename }) => {
  const _src = useMemo(() => iframeURL(src), [src]);
  return <iframe className="gen-file-viewer__container" src={_src} title={filename} />;
};
